import { render, staticRenderFns } from "./ColumnWebsite.vue?vue&type=template&id=5d998f69&scoped=true"
import script from "./ColumnWebsite.vue?vue&type=script&lang=js"
export * from "./ColumnWebsite.vue?vue&type=script&lang=js"
import style0 from "./ColumnWebsite.vue?vue&type=style&index=0&id=5d998f69&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d998f69",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d998f69')) {
      api.createRecord('5d998f69', component.options)
    } else {
      api.reload('5d998f69', component.options)
    }
    module.hot.accept("./ColumnWebsite.vue?vue&type=template&id=5d998f69&scoped=true", function () {
      api.rerender('5d998f69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Documents/Conferences/Columns/ColumnWebsite.vue"
export default component.exports